/**
 * @file newCollegeStudentDemographics.js
 * @author Jake Stark
 * @desc outStateCollegeStudentEnrollment report plugin

*/

/**
 * @module outStateCollegeStudentEnrollment 
 * @desc outStateCollegeStudentEnrollment report plugin
 */

define('plugins/outStateCollegeStudentEnrollment',["underscore",
        "cardboard/models", "cardboard/collections", "cardboard/util",
        "text!plugins/templates/outStateCollegeStudentEnrollment_gender_table.html!strip",
        "text!plugins/templates/outStateCollegeStudentEnrollment_outStateByState_table.html!strip",
        "text!plugins/templates/outStateCollegeStudentEnrollment_outStateByCollegeSelectivity_table.html!strip",
        "text!plugins/templates/outStateCollegeStudentEnrollment_outStateByInstitutionType_table.html!strip",
        "text!plugins/templates/outStateCollegeStudentEnrollment_persistence_table.html!strip",
        "text!plugins/templates/outStateCollegeStudentEnrollment_raceEthnicity_table.html!strip",
        "text!plugins/templates/outStateCollegeStudentEnrollment_specialChar_table.html!strip",
        "text!plugins/templates/outStateCollegeStudentEnrollment_TopSchools_table.html!strip", "text!plugins/templates/outStateCollegeStudentEnrollment_TopTenDegrees_table.html!strip",
        "text!plugins/templates/outStateCollegeStudentEnrollment_actScore_table.html!strip", "models", "cardboard/pluginPieces"
    ],
    function (_,
        CardboardModels, CardboardCollections, Util, genderTemplate, outStateByStateTemplate, outStateByCollegeSelectivityTemplate, outStateByInstitutionTypeTemplate, persistenceTemplate, raceEthnicityTemplate,
        specialCharTemplate, topSchoolsTemplate, topTenDegreesTemplate, actScoreTemplate, SLEDSModels, PluginPieces) {

        console.log("MODULE: outStateCollegeStudentEnrollment");

        var exports = {

            // options for the demo cats config. since this is a multi-select
            // report, we have to use a different view object, and tell it not to
            // show grades as categories.
            options: {
                //    dynamicTextDomain: "outStateCollegeStudentEnrollment",
                orgDetailPane: false,
                noMapSearch: true,
                forcedSummaryFilters: ["outStateCollegeCOHORTID"],
                // Show Filter definitions link at bottom of filter pane
                definitions: true
            },

            // each of these is the configuration that gets passed to a
            // DataBoxPaneView.
            panes: [{
                    title: "Enrollment by College State",
                    //    explanationText: "This report shows new entering students by State of Residence. ",
                    openByDefault: true,
                    views: [{
                            // SETUP
                            type: "pie",
                            dataSourceName: "data",
                            //  dataSetPath: "outStateByGender",
                            dataPath: "outStateByState.data[1].slice",

                            dataShape: "pointsWithinRows",

                            convertDataHashToArray: true,
                            dataDimensions: 1,
                            title: "",

                            // DISPLAY
                            unitString: "%",
                            unitDec: 0,

                            showLegend: true,
                            dataLabels: false,

                            // SERIES (only one series, this is a simple graph)
                            series: [{
                                valuePath: "percent",
                                displayNamePath: "name",

                            }],
                            // errorConditions: [PluginPieces.standardErrorCondition]
                            errorConditions: [{
                                valuePath: "data.data[0]",
                                is: undefined,
                                error: {
                                    type: "NoData",
                                    message: "Data is not available for current selection(s)."
                                }
                            }]

                        },
                        {
                            type: "template",
                            template: outStateByStateTemplate,
                            dataSourceName: "data",
                            dataSetPath: "outStateByState",
                            errorConditions: [PluginPieces.silentStandardErrorCondition]
                        }
                    ]
                },
                {
                    title: "Enrollment by Institution Type",

                    //    explanationText: "This report shows new entering students by State of Residence. ",
                    openByDefault: false,
                    views: [{
                            // SETUP
                            type: "pie",
                            dataSourceName: "data",
                            //  dataSetPath: "outStateByGender",
                            dataPath: "outStateByInstitutionType.data[0].slice",

                            dataShape: "pointsWithinRows",

                            convertDataHashToArray: true,
                            dataDimensions: 1,
                            title: "",

                            // DISPLAY
                            unitString: "%",
                            unitDec: 0,

                            showLegend: true,
                            dataLabels: false,

                            // SERIES (only one series, this is a simple graph)
                            series: [{
                                valuePath: "percent",
                                displayNamePath: "name",

                            }],
                            // errorConditions: [PluginPieces.standardErrorCondition]
                            errorConditions: [{
                                valuePath: "data.data[0]",
                                is: undefined,
                                error: {
                                    type: "NoData",
                                    message: "Data is not available for current selection(s)."
                                }
                            }]

                        },
                        {
                            type: "template",
                            template: outStateByInstitutionTypeTemplate,
                            dataSourceName: "data",
                            dataSetPath: "outStateByInstitutionType",
                            errorConditions: [PluginPieces.silentStandardErrorCondition]
                        }
                    ]
                },
                {
                    title: "Enrollment by College Selectivity",
                    //    explanationText: "This report shows new entering students by State of Residence. ",
                    openByDefault: false,
                    views: [{
                            // SETUP
                            type: "pie",
                            dataSourceName: "data",
                            //  dataSetPath: "outStateByGender",
                            dataPath: "outStateByCollegeSelectivity.data[0].slice",

                            dataShape: "pointsWithinRows",

                            convertDataHashToArray: true,
                            dataDimensions: 1,
                            title: "",

                            // DISPLAY
                            unitString: "%",
                            unitDec: 0,

                            showLegend: true,
                            dataLabels: false,

                            // SERIES (only one series, this is a simple graph)
                            series: [{
                                valuePath: "percent",
                                displayNamePath: "name",

                            }],
                            // errorConditions: [PluginPieces.standardErrorCondition]
                            errorConditions: [{
                                valuePath: "data.data[0]",
                                is: undefined,
                                error: {
                                    type: "NoData",
                                    message: "Data is not available for current selection(s)."
                                }
                            }]

                        },
                        {
                            type: "template",
                            template: outStateByCollegeSelectivityTemplate,
                            dataSourceName: "data",
                            dataSetPath: "outStateByCollegeSelectivity",
                            errorConditions: [PluginPieces.silentStandardErrorCondition]
                        }
                    ]
                },

                {
                    title: "Gender",
                    //    explanationText: "This report shows new entering students by State of Residence. ",
                    openByDefault: false,
                    views: [{
                            // SETUP
                            type: "pie",
                            dataSourceName: "data",
                            //  dataSetPath: "outStateByGender",
                            dataPath: "outStateByGender.data[0].slice",

                            dataShape: "pointsWithinRows",

                            convertDataHashToArray: true,
                            dataDimensions: 1,
                            title: "",

                            // DISPLAY
                            unitString: "%",
                            unitDec: 0,

                            showLegend: true,
                            dataLabels: false,

                            // SERIES (only one series, this is a simple graph)
                            series: [{
                                valuePath: "percent",
                                displayNamePath: "name",

                            }],
                            // errorConditions: [PluginPieces.standardErrorCondition]
                            errorConditions: [{
                                valuePath: "data.data[0]",
                                is: undefined,
                                error: {
                                    type: "NoData",
                                    message: "Data is not available for current selection(s)."
                                }
                            }]

                        },
                        {
                            type: "template",
                            template: genderTemplate,
                            dataSourceName: "data",
                            dataSetPath: "outStateByGender",
                            errorConditions: [PluginPieces.silentStandardErrorCondition]
                        }
                    ]
                },
                {
                    title: "Race/Ethnicity",
                    //    explanationText: "This report shows new entering students by State of Residence. ",
                    openByDefault: false,
                    views: [{
                            // SETUP
                            type: "pie",
                            dataSourceName: "data",
                            //  dataSetPath: "outStateByGender",
                            dataPath: "outStateByRace.data[0].slice",
                            // all paths in the
                            // chartable series are
                            // relative to this blob

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",

                            // since in this case there's only one dimension, due to
                            // there being only one series to plot, it looks like
                            // this:
                            //	 +---------+
                            //	 | X X X X |
                            //	 +---------+
                            convertDataHashToArray: true,
                            dataDimensions: 1,
                            title: "",

                            // DISPLAY
                            unitString: "%",
                            unitDec: 0,
                            showLegend: true,
                            dataLabels: false,

                            // SERIES (only one series, this is a simple graph)
                            series: [{
                                valuePath: "values[0].percent",
                                displayNamePath: "name",

                            }],

                            errorConditions: [{
                                valuePath: "data.data[0]",
                                is: undefined,
                                error: {
                                    type: "NoData",
                                    message: "Data is not available for current selection(s)."
                                }
                            }]

                        },
                        {
                            type: "template",
                            template: raceEthnicityTemplate,
                            dataSourceName: "data",
                            dataSetPath: "outStateByRace",
                            errorConditions: [PluginPieces.silentStandardErrorCondition]
                        }
                    ]
                },

                {
                    title: "Special Characteristics",
                    //    explanationText: "This report shows new entering students by county.",

                    openByDefault: false,
                    views: [{
                        type: "template",
                        template: specialCharTemplate,
                        dataSourceName: "data",
                        errorConditions: [{
                            valuePath: "data.data.outStateBySpecialCharacteristic.data[0]",
                            is: undefined,
                            error: {
                                type: "NoData",
                                message: "Data is not available for current selection(s)."
                            }
                        }]
                    }]
                },
                {
                    title: "ACT Score",
                    //    explanationText: "This report shows new entering students by county.",

                    openByDefault: false,
                    views: [{
                        type: "template",
                        template: actScoreTemplate,
                        dataSourceName: "data",
                        errorConditions: [{
                            valuePath: "data.data.outStateActScores.data[0]",
                            is: undefined,
                            error: {
                                type: "NoData",
                                message: "Data is not available for current selection(s)."
                            }
                        }]
                    }]
                },
                {
                    title: "Persistence Rate 1st to 2nd Year",
                    openByDefault: false,
                    views: [{
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "outStateByPersistence.data[0].slice",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 1,
                            convertDataHashToArray: true,
                            // DISPLAY
                            unitString: "%",
                            showLegend: false,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                    // dataPath: "data",
                                    valuePath: "percent",
                                    displayNamePath: "name",
                                }

                            ],
                            errorConditions: [{
                                valuePath: "data.data[0]",
                                is: undefined,
                                error: {
                                    type: "NoData",
                                    message: "Data is not available for current selection(s)."
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: persistenceTemplate,
                            dataSourceName: "data",
                            dataSetPath: "outStateByPersistence",
                            errorConditions: [PluginPieces.silentStandardErrorCondition]
                        }
                    ]
                },
                {
                    title: "Completion Rate",
                    openByDefault: false,
                    views: [{
                            // SETUP
                            // one glob = one line series
                            // in each series, one row = one data point
                            type: "column",
                            dataSourceName: "data",
                            dataPath: "outStateByCompletion.data[0].slice",

                            // "pointsWithinRows": given that the data is
                            // two-dimensional (meaning an array of arrays, or
                            // similar structure, implying that we have more than
                            // one series to plot) each series is contained in a
                            // "row", like so:
                            //	 +---------+
                            //	 | X X X X |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 | . . . . |
                            //	 +---------+
                            dataShape: "pointsWithinRows",
                            dataDimensions: 1,
                            convertDataHashToArray: true,
                            // DISPLAY
                            unitString: "%",
                            showLegend: false,

                            // SERIES
                            // each series has two points, and is an organization
                            series: [{
                                    // dataPath: "data",
                                    valuePath: "percent",
                                    displayNamePath: "name",
                                }

                            ],
                            errorConditions: [{
                                valuePath: "data.data[0]",
                                is: undefined,
                                error: {
                                    type: "NoData",
                                    message: "Data is not available for current selection(s)."
                                }
                            }]
                        },
                        {
                            type: "template",
                            template: persistenceTemplate,
                            dataSourceName: "data",
                            dataSetPath: "outStateByCompletion",
                            errorConditions: [PluginPieces.silentStandardErrorCondition]
                        }
                    ]
                },
                /*             {
                                title: "Top 10 Degrees/Majors Completed",
                            //    explanationText: "This report shows new entering students by county.",
                
                                openByDefault: false,
                                views: [
                                    {
                                        type: "template",
                                        template: topTenDegreesTemplate,
                                        dataSourceName: "data",
                                         errorConditions: [
                                            {
                                                valuePath: "data.data.topSchools.data[0]",
                                                is: undefined,
                                                error: {
                                                    type: "NoData",
                                                    message: "Data is not available for current selection(s)."
                                                }
                                            }
                                        ] 
                                    }
                                ]
                            }, */
                {
                    title: "Top 25 High Schools of Origin",
                    //    explanationText: "This report shows new entering students by county.",

                    openByDefault: false,
                    views: [{
                        type: "template",
                        template: topSchoolsTemplate,
                        dataSourceName: "data",
                        errorConditions: [{
                            valuePath: "data.data.topSchools.data[0]",
                            is: undefined,
                            error: {
                                type: "NoData",
                                message: "Data is not available for current selection(s)."
                            }
                        }]
                    }]
                },

                {
                    title: "More Information",
                    visibleByDefault: true,
                    openByDefault: true,
                    views: [{
                        type: "template",
                        template: "<p><a href='/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_outstatecollege.fex&orgId=999999000&orgName=Statewide&groupType=state&COLLEGE_STATE=FOC_NONE&INSTITUTION_TYPE=FOC_NONE&COLLEGE_SELECTIVITY=FOC_NONE&outStateCollegeCOHORTID=2018&outputFormat=XLSX' data-role='button' class='ui-link ui-btn ui-shadow ui-corner-all' role='button'>Download All Data</a></p><p>These reports show information about Minnesota public high school graduates enrolling in postsecondary institutions in states other than Minnesota. This data is obtained from the National Student Clearinghouse for the 8 years immediately following high school graduation.  For more information on National Student Clearinghouse Data, please visit the <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=059077&RevisionSelectionMethod=latestReleased&Rendition=primary'>Data Interpretation Guide</a>.</p><p><a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde031878&RevisionSelectionMethod=latestReleased&Rendition=primary'>Download web report data</a> for all high schools and years. Please note this file does not include subgroup statistics. For more information, <a href='https://education.mn.gov/mdeprod/idcplg?IdcService=GET_FILE&dDocName=mde031756&RevisionSelectionMethod=latestReleased&Rendition=primary'>read the help document</a>.</p>"
                    }]
                }
            ],

            filterSources: {
                orgs: {
                    modelType: SLEDSModels.SLEDSOrgList,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_outstatecollegeorg.fex",
                    noViewParams: true,
                    enabled: true
                },
                filters: {
                    modelType: CardboardModels.FilterProducer,
                    filterSources: ["filterForReport"],
                    urls: {
                        filterForReport: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_outstatecollegedropdown.fex"
                    },

                    enabled: true,
                },
                filters2: {
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_outstatecollegecohortid.fex",
                    enabled: true,
                    modelType: CardboardModels.FilterData
                },
                filters3: {
                    modelType: CardboardModels.FilterProducer,
                    filterSources: ["filterForReport"],
                    urls: {
                        filterForReport: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_outstatecollegedropdown2.fex",
                    },
                    enabled: true,
                }, 
                demographicCategories: {
                    modelType: CardboardCollections.DemoCatProducer,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_filter_outstatecollegebuttons.fex",
                    enabled: true,
                    noViewParams: false,
                    isCat: true
                }
            },
            dataSources: {
                data: {
                    modelType: CardboardModels.DocumentModel,
                    url: "/ibi_apps/WFServlet?IBIAPP_app=SLEDSwebsvc&IBIF_ex=sledsws_getdata_outstatecollege.fex",
                    yearPath: "dataYear",
                    defaultParams: {
                        orgId: 999999000,
                        //      newCollegeStudentDemographicsCOHORTID: 2016
                    },
                    paramMappings: {
                        //   newCollegeStudentDemographicsCOHORTID: "dataYear",
                        //      PS_ORGID: "orgId",
                        //      orgName: null // skip this
                    },
                    enabled: true,
                     errorConditions: [{
                        valuePath: "errorMessage",
                        isNot: null,
                        error: {
                            type: "NoData",
                            message: "Data is not available."
                        }
                    }] 
                }
            }
        };

        return exports;
    });
